import { styled } from "styled-components";

import { Stack } from "@similarweb/ui-components/foundations";

export const SELECTION_COLUMN_WIDTH = 58;

export const StyledTableCardWrapper = styled(Stack)`
    col.ant-table-selection-col,
    .ant-table-selection-col,
    th.ant-table-selection-column,
    td.ant-table-selection-column {
        width: ${SELECTION_COLUMN_WIDTH}px !important;
        min-width: ${SELECTION_COLUMN_WIDTH}px !important;
        max-width: ${SELECTION_COLUMN_WIDTH}px !important;
    }

    [data-automation="table-top-selection-checkbox"] {
        padding-left: 0;

        .ant-checkbox-wrapper {
            margin-left: -12px;
            margin-right: 12px;
            width: ${SELECTION_COLUMN_WIDTH}px;
            height: 56px;
            justify-content: center;
        }
    }
`;
